import React from 'react'
import SliderHomeReviews from '../../component/slidercomponent/SliderHomeReviews'

const HomeReviews = () => {
    return (
        <>

            <section className="renvia-testimonial-sec pt-115 pb-120" style={{ marginTop: "-190px" }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="section-title text-center mb-45">
                                <span className="sub-title aos-init" data-aos-duration={1000}><img src="assets/images/line1.png" alt="line" />What Said About Us<img src="assets/images/line2.png" alt="line" /></span>
                                <h2 className="text-anm" aria-label="Testimonials and Clients">
                                    What Our Customers Are Saying
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="testimonial-slider-three aos-init slick-initialized slick-slider" data-aos-duration={1000}>
                        <div className="slick-list draggable">
                            <div className="slick-track">
                                
                                <SliderHomeReviews />
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default HomeReviews